import { ProjectType } from '@cartwhl/common/types';
import { getStudioUrl } from '@cartwhl/common/utils/getStudioUrl';
import PlusIcon from '@cartwhl/ui/icons/PlusIcon';
import Button from '@cartwhl/ui/input/Button';

import { projectStore, sceneSettingsStore } from 'stores';

export default function NewProjectDropdown({
  className,
}: {
  className?: string;
}) {
  const handleCreateMotion = async () => {
    sceneSettingsStore.reset();
    const projectData = await projectStore.createNewProject(ProjectType.MOTION);
    if (projectData) {
      window.location.href = `${getStudioUrl()}/motion/${projectData.projectID}`;
    }
  };

  return (
    <Button
      variant="secondary"
      size="sm"
      icon={<PlusIcon />}
      className={`text-gray-90 ${className}`}
      onClick={handleCreateMotion}
    >
      Create new motion
    </Button>
  );
}
